// src/pages/FormPage/services/fetchFromGitHub.js
import axios from 'axios';

/**
 * Função utilitária para buscar e decodificar arquivos do GitHub
 * @param {string} account
 * @param {string} project
 * @param {string} formid
 * @param {string} filename - nome do arquivo, ex: 'formschema.json'
 * @param {Function} setState - setState React para atualizar o estado correspondente
 */
export async function fetchFromGitHub(account, project, formid, filename, setState) {
  try {
    const config = {
      method: 'get',
      url: `https://api.github.com/repos/OctavioSI/api-juridica-aux/contents/json-schema-form/${account}/${project}/${formid}.${filename}`,
      headers: {
        'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`
      }
    };

    const response = await axios(config);
    if (response?.data?.content) {
      const content = decodeURIComponent(escape(atob(response.data.content)));
      const isJSON = filename.endsWith('.json') || filename.endsWith('.formfunctions.js');
      setState(isJSON ? JSON.parse(content) : content);
      console.log(`✅ Loaded: ${filename}`);
    }
  } catch (e) {
    console.warn(`⚠️  Not found: ${filename}`, e.message);
  }
}
